export enum Documents {
  getS3 = 'documents',
}
